import { z } from "zod";

export const MAX_REJECTION_COMMENT_LENGTH = 1000;

export interface RejectDeliveryValues {
  reason: string;
  comment: string;
}

export const createRejectDeliverySchema = (requiredMessage: string, tooLongMessage: string) =>
  z.object({
    reason: z.string().min(1, requiredMessage),
    comment: z.string().max(MAX_REJECTION_COMMENT_LENGTH, tooLongMessage),
  });
